import React, { Component } from "react";

import { ReactComponent as Backend } from "../../assests/images/backend.svg";

export default class BackendImg extends Component {
  render() {
    return <Backend />;
  }
}
